import kpiPageCopy from '../../pages/influencer/InfluencerDashboard/InfluencerKPIs/influencerKpiPageCopy';

/** Canonical dashboard insight list routes (SEO-friendly slugs). */
export const INFLUENCER_INSIGHT_PATHS = {
  collaborationJourney: '/dashboard/collaboration-journey',
  analytics: '/dashboard/analytics',
};

export const INFLUENCER_ANALYTICS_VIEW_KEYS = [
  'applications',
  'invites',
  'following',
  'saved',
];

export const INFLUENCER_ANALYTICS_DEFAULT_VIEW = 'applications';

export const INFLUENCER_ANALYTICS_TABS = [
  { value: 'applications', label: 'Application over time' },
  { value: 'invites', label: 'Invites over time' },
  { value: 'following', label: 'Following brands' },
  { value: 'saved', label: 'Saved campaigns' },
];

export const getInfluencerInsightPageUrl = (pageKey) => (
  INFLUENCER_INSIGHT_PATHS[pageKey] || ''
);

export function parseInfluencerAnalyticsView(searchParams) {
  const view = typeof searchParams?.get === 'function'
    ? searchParams.get('view')
    : null;
  return INFLUENCER_ANALYTICS_VIEW_KEYS.includes(view)
    ? view
    : INFLUENCER_ANALYTICS_DEFAULT_VIEW;
}

/** Canonical analytics path including ?view= */
export function getInfluencerAnalyticsPath(view = INFLUENCER_ANALYTICS_DEFAULT_VIEW) {
  const safeView = INFLUENCER_ANALYTICS_VIEW_KEYS.includes(view)
    ? view
    : INFLUENCER_ANALYTICS_DEFAULT_VIEW;
  return `${INFLUENCER_INSIGHT_PATHS.analytics}?view=${safeView}`;
}

const pageSeo = {
  collaborationJourney: {
    title: 'Collaboration Journey',
    description: kpiPageCopy.collaborationJourney.pageIntro,
    canonicalPath: INFLUENCER_INSIGHT_PATHS.collaborationJourney,
  },
  analytics: {
    title: 'Analytics',
    description: 'The brands and campaigns you are choosing to grow with.',
    canonicalPath: INFLUENCER_INSIGHT_PATHS.analytics,
  },
};

export const getInfluencerInsightPageSeo = (pageKey) => pageSeo[pageKey] || null;
